import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useTicket(ticketId) {
  const { data, _error, isLoading, isValidating, mutate } = useSWR(
    ticketId ? `/tickets/${ticketId}` : null,
    (url) => fetcher(url),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );

  return {
    ticket: data,
    isLoading: isLoading,
    isValidating: isValidating,
    mutate: mutate,
  };
}

export default useTicket;
